import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@hobs/components/Icon';
import WithRoles from '@hobs/hocs/WithRoles';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import Confirm from '@hobs/components/Confirm';
import { withTranslation } from 'react-i18next';
import Discussion from '@hobs/containers/Discussion';

import './HeadingActions.scss';

class HeadingActions extends React.PureComponent {
  isActive(path) {
    return path === this.props.location.pathname;
  }

  navigateTo(path) {
    if (this.props.isDirty) {
      Confirm(
        this.props.t('Cancel service request'),
        this.props.t(
          'Are you sure you want to cancel? All entered data will be lost.'
        ),
        () => {
          this.props.history.push(path);
        }
      );
    } else {
      this.props.history.push(path);
    }
  }

  render() {
    const {
      isTransportation,
      showPath,
      editPath,
      historyPath,
      discussion,
      transportationPath,
      changeHistoryPath,
      discussionPath,
    } = this.props;
    return (
      <div className="heading-actions">
        {showPath && (
          <Link
            className={this.isActive(showPath) ? 'heading-actions--active' : ''}
            to={showPath}
            onClick={e => {
              e.preventDefault();
              this.navigateTo(showPath);
            }}
          >
            <Icon icon="Info" />
          </Link>
        )}
        {editPath && (
          <Link
            className={this.isActive(editPath) ? 'heading-actions--active' : ''}
            to={editPath}
            onClick={e => {
              e.preventDefault();
              this.navigateTo(editPath);
            }}
          >
            <Icon icon="Pen" />
          </Link>
        )}
        {historyPath && (
          <Link
            className={
              this.isActive(historyPath) ? 'heading-actions--active' : ''
            }
            to={historyPath}
            onClick={e => {
              e.preventDefault();
              this.navigateTo(historyPath);
            }}
          >
            <Icon icon="History" />
          </Link>
        )}
        {isTransportation && (
          <Link
            className={
              this.isActive(transportationPath) ? 'heading-actions--active' : ''
            }
            to={transportationPath}
            onClick={e => {
              e.preventDefault();
              this.navigateTo(transportationPath);
            }}
          >
            <Icon icon="Truck" />
          </Link>
        )}

        {discussion && (
          <Link to={discussionPath}>
            <Discussion {...discussion } />
          </Link>
        )}

        {changeHistoryPath && (
          <Link
            className={
              this.isActive(changeHistoryPath) ? 'heading-actions--active' : ''
            }
            to={changeHistoryPath}
            onClick={e => {
              e.preventDefault();
              this.navigateTo(changeHistoryPath);
            }}
          >
            <Icon icon="Change" />
          </Link>
        )}
      </div>
    );
  }
}

HeadingActions.propTypes = {
  onNavigate: PropTypes.func,
  showPath: PropTypes.string,
  editPath: PropTypes.string,
  transportationPath: PropTypes.string,
  isDirty: PropTypes.bool,
  isTransportation: PropTypes.bool,
  historyPath: PropTypes.string,
  changeHistoryPath: PropTypes.string,
  history: PropTypes.object,
  t: PropTypes.func,
  discussion: PropTypes.shape({
    serviceRequestId: PropTypes.string,
    status: PropTypes.number,
    initials: PropTypes.string,
    iconOnly: PropTypes.bool
  }),
  location: PropTypes.shape({
    pathname: PropTypes.string
  }),
  hasUserPermission: PropTypes.func,
  discussionPath: PropTypes.string,
};

export default withTranslation()(withRouter(WithRoles(HeadingActions)));
